
import dollarIcon from "../../assets/icons/dollar_icon.png";
import editIcon from "../../assets/icons/edit_icon.png";
import editIconHover from "../../assets/icons/edit-hover.png";
import downloadIcon from "../../assets/icons/excel_download_icon.png";
import downloadIconHover from "../../assets/icons/excel_download_icon_hover.png";
import filled from "../../assets/icons/filled.png";
import filledRequisition from "../../assets/icons/filled_requisition.png";
import flagIcon from "../../assets/icons/flag_icon.png";
import infoIcon from "../../assets/icons/info_icon.png";
import onHold from "../../assets/icons/on_hold.png";
import open from "../../assets/icons/open.png";
import openIcon from "../../assets/icons/open_kpi_icon.png";
import rejected from "../../assets/icons/rejected.png";
import rightArrowIcon from "../../assets/icons/right_arrow_icon.png";
import rightArrowIconHover from "../../assets/icons/right_arrow_icon_hover.png";
import shuffleIcon from "../../assets/images/shuffle_icon.png";
import taskFileIcon from "../../assets/icons/task_file_icon.png";
import tickIcon from "../../assets/icons/tick_while_icon.png";
import totalSpend from "../../assets/icons/total_Spend.png";
import users from "../../assets/icons/user_icon.png";
import ringoVitalLogo from "../../assets/icons/logo_RingoVitals.png";
import excelLogo from "../../assets/icons/scheduler_icon/excel-icon.svg";


export default {
    dollarIcon,
    editIcon,
    editIconHover,
    downloadIcon,
    downloadIconHover,
    filled,
    filledRequisition,
    flagIcon,
    infoIcon,
    onHold,
    open,
    openIcon,
    rejected,
    rightArrowIcon,
    rightArrowIconHover,
    shuffleIcon,
    taskFileIcon,
    tickIcon,
    totalSpend,
    users,
    ringoVitalLogo,
    excelLogo,
};